export type ForegroundWebglKind = 'three' | 'maplibre';

interface ForegroundWebglOwner {
  kind: ForegroundWebglKind;
  label: string;
}

const owners = new Map<symbol, ForegroundWebglOwner>();

declare global {
  // Nom historique conservé pour les garde-fous d'App.vue. Il signifie
  // désormais qu'un rendu WebGL de premier plan détient le GPU.
  // eslint-disable-next-line no-var
  var __GUILD_MAP3D_ACTIVE__: boolean | undefined;
}

function publishForegroundState() {
  const active = owners.size > 0;
  globalThis.__GUILD_MAP3D_ACTIVE__ = active;
  const detail = {
    actif: active,
    owners: [...owners.values()].map(owner => ({ ...owner })),
  };
  window.dispatchEvent(new CustomEvent('guild-foreground-webgl-active', { detail }));
  window.dispatchEvent(new CustomEvent('guild-map3d-actif', { detail }));
}

export function acquireForegroundWebgl(owner: ForegroundWebglOwner) {
  window.dispatchEvent(new CustomEvent('guild-foreground-webgl-request', {
    detail: { ...owner },
  }));

  const token = Symbol(owner.label);
  owners.set(token, owner);
  publishForegroundState();

  let released = false;
  return () => {
    if (released) return;
    released = true;
    owners.delete(token);
    publishForegroundState();
  };
}

export function isForegroundWebglActive() {
  return owners.size > 0;
}

